const AdminRouter = [

    {
        path: "/admin-login",
        name: "login",
        meta: {
            requireAuth: false
        },
        component: () => import("@/Views/LoginPage.vue")
    },


    {
        path: "/",
        name: "adminMain",
        component: () => import("@/Views/adminMain.vue"),
        children: [
            {
                path: "admin-dashbord",
                name: "dashbord",
                meta: {
                    requireAuth: false
                },
                component: () => import("@/Views/DashbordPage.vue")
            },
            {
                path: "monthly-interactivity",
                name: "monthly-interactivity",
                meta: {
                    requireAuth: false
                },
                component: () => import("@/Views/MonthlyInteractivity.vue")
            },
            {
                path: "monthly-signins",
                name: "monthly-signins",
                meta: {
                    requireAuth: false
                },
                component: () => import("@/Views/MonthlySignIns.vue")
            },
            {
                path: "MonthlyExpertSignins",
                name: "MonthlyExpertSignins",
                meta: {
                    requireAuth: false
                },
                component: () => import("@/Views/MonthlyExpertSignin.vue")
            },
            {
                path: "active-user",
                name: "active-user",
                meta: {
                    requireAuth: false
                },
                component: () => import("@/Views/ActiveUsers.vue")
            }, {
                path: "admin-emails",
                name: "Emails",
                meta: {
                    requireAuth: false
                },
                component: () => import("@/Views/EmailPage.vue")
            },
            {
                path: "user-Posts",
                name: "user-Posts",
                meta: {
                    requireAuth: false
                },
                component: () => import("@/Views/UserPosts.vue")
            },
            {
                path: "expert-category",
                name: "expert-category",
                meta: {
                    requireAuth: false
                },
                component: () => import("@/Views/Experts/ExpertCategory.vue")
            },
            {
                path: "expert-status",
                name: "expert-status",
                meta: {
                    requireAuth: false
                },
                component: () => import("@/Views/Experts/ExpertStatus.vue")
            },

            {
                path: "AI-usage",
                name: "AI-usage",
                meta: {
                    requireAuth: false
                },
                component: () => import("@/Views/AiUsage.vue")
            },
            {
                path: "reported-posts",
                name: "reported-posts",
                meta: {
                    requireAuth: false
                },
                component: () => import("@/Views/ReportedPost.vue")
            },
            {
                path: "MonthActiveUsersAndExperts",
                name: "MonthActiveUsersAndExperts",
                meta: {
                    requireAuth: false
                },
                component: () => import("@/Views/MonthActiveUsersAndExperts.vue")
            },
            {
                path: "EmailVerifier",
                name: "EmailVerifier",
                meta: {
                    requireAuth: false
                },
                component: () => import("@/Views/EmailVerifier.vue")
            },
            {
                path: "expertLocation",
                name: "expertLocation",
                meta: {
                    requireAuth: false
                },
                component: () => import("@/Views/Experts/ExpertLocation.vue")
            }, {
                path: "expertProfile/:id?",
                name: "expertProfile",
                meta: {
                    requireAuth: false
                },
                component: () => import("@/Views/Experts/ExpertProfile.vue")
            },{
                path: "user-location",
                name: "user-location",
                meta: {
                    requireAuth: false
                },
                component: () => import("@/Views/UserPerLocation.vue")
            }
            ,{
                path: "expertStatus",
                name: "expertStatus",
                meta: {
                    requireAuth: false
                },
                component: () => import("@/Views/Experts/ExpertStatus.vue")
            }


        ]
    }
]

export default AdminRouter;